import { render, staticRenderFns } from "./categoryCard.component.vue?vue&type=template&id=1bccd813&scoped=true&"
import script from "./categoryCard.component.vue?vue&type=script&lang=js&"
export * from "./categoryCard.component.vue?vue&type=script&lang=js&"
import style0 from "./categoryCard.component.vue?vue&type=style&index=0&id=1bccd813&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bccd813",
  null
  
)

export default component.exports